import { Text, TextStyles } from '@cinch-labs/design-system'
import { getDayMonthYearFormat } from '@cinch-labs/shared-util'
import type { StoryblokImage } from '@cinch-nx/data-storyblok'
import cx from 'classnames'
import Image from 'next/legacy/image'

import styles from './article-card.module.css'

export interface ArticleCardProps {
  title: string
  date: string
  image: StoryblokImage
  featured?: boolean
}

export const ArticleCard: React.FC<ArticleCardProps> = ({
  title = '',
  image,
  date = '',
  featured = false,
}) => (
  <article
    className={cx(styles['root'], {
      [styles['topCard']]: featured,
    })}
    data-featured={featured}
    data-uid={title}
  >
    <div
      className={cx(styles['imageContainer'], {
        [styles['featured']]: featured,
      })}
    >
      <Image
        className={styles['image']}
        alt={image?.alt ?? ''}
        src={
          image?.filename ||
          `${
            process.env['STAGE_NAME'] === 'local'
              ? ''
              : process.env['STAGE_URL']
          }/image-coming-soon.svg`
        }
        layout="responsive"
        width={featured ? 400 : 250}
        height={featured ? 253 : 158}
        priority={featured}
      />
    </div>

    <div>
      <Text
        type={featured ? TextStyles.vehicleTitle : TextStyles.mainTitle}
        element="h3"
        className={styles['title']}
        lineHeight="display"
      >
        {title}
      </Text>

      <time dateTime={date} className={styles['date']}>
        {getDayMonthYearFormat(date)}
      </time>
    </div>
  </article>
)
